import { useMemo } from 'react'

import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'

import Page from 'app/layout/Page'
import { DataReport } from 'app/lib/components/DataReport'
import { DynamicBanner } from 'app/lib/components/DynamicBanner'
import { useTrackReportView } from 'app/lib/hooks/use-track-report-view'
import { setOrganizationAttributes } from 'app/lib/utils/sprig'
import { OrganizationRoute } from 'app/models/scribe.models'
import { useLegacyGetOrganizationQuery } from 'app/redux/scribeApi'

export const OrganizationReportsPage: React.FC = () => {
  const { t } = useTranslation()
  const { organizationId } = useParams() as OrganizationRoute

  const {
    data: organization,
    isLoading: orgLoading,
    isError: orgError,
  } = useLegacyGetOrganizationQuery(organizationId)

  setOrganizationAttributes(organization, organizationId)

  const isReportReady = useMemo(() => {
    return !orgLoading && !orgError
  }, [orgLoading, orgError])

  const organizationIds = useMemo(() => [organizationId], [organizationId])

  useTrackReportView({
    isReportReady,
    reportType: 'single_organization',
    organizationIds,
    reportPlatform: 'evidence',
  })

  return (
    <Page>
      <DynamicBanner pageKey={'organization-reports'} />
      <Typography variant="h1" sx={{ mb: 2 }} data-testid="page-title">
        {t('organizationReportsPage.pageTitle', { organizationName: organization?.name })}
      </Typography>

      {isReportReady && (
        <Box sx={{ mt: 1, height: '80vh', pb: 0 }}>
          <DataReport organizationIds={organizationIds} />
        </Box>
      )}
    </Page>
  )
}
